/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_Offersyear1Inputs */

const id_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran (Tahun)`)
};

const ms_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran (Tahun)`)
};

const da_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud (År)`)
};

const de_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote (Jahr)`)
};

const en_us2_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers (Year)`)
};

const es_es2_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas (Año)`)
};

const es_mx2_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas (Año)`)
};

const fil_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Offer (Taon)`)
};

const fr_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres (Année)`)
};

const it_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte (Anno)`)
};

const hu_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlatok (Év)`)
};

const nl_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbiedingen (Jaar)`)
};

const no_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud (År)`)
};

const pl_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferty (rok)`)
};

const pt_br2_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers per year`)
};

const pt_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas (Ano)`)
};

const ro_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte (An)`)
};

const fi_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjoukset (vuosi)`)
};

const sv_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudanden (År)`)
};

const vi_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi (Năm)`)
};

const tr_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifler (Yıl)`)
};

const cs_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky (rok)`)
};

const bg_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оферти (година)`)
};

const ru_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложений (год)`)
};

const uk_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропозицій (Рік)`)
};

const ar_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العروض (سنة)`)
};

const hi_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र (वर्ष)`)
};

const th_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอ (ปี)`)
};

const ja_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファー (年間)`)
};

const zh_cn2_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers per year`)
};

const zh_hant1_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers per year`)
};

const ko_components_stats_offersyear1 = /** @type {(inputs: Components_Stats_Offersyear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers per year`)
};

/**
* | output |
* | --- |
* | "Offers (Year)" |
*
* @param {Components_Stats_Offersyear1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_offersyear1 = /** @type {((inputs?: Components_Stats_Offersyear1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_Offersyear1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_offersyear1(inputs)
	if (locale === "ms") return ms_components_stats_offersyear1(inputs)
	if (locale === "da") return da_components_stats_offersyear1(inputs)
	if (locale === "de") return de_components_stats_offersyear1(inputs)
	if (locale === "en-US") return en_us2_components_stats_offersyear1(inputs)
	if (locale === "es-ES") return es_es2_components_stats_offersyear1(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_offersyear1(inputs)
	if (locale === "fil") return fil_components_stats_offersyear1(inputs)
	if (locale === "fr") return fr_components_stats_offersyear1(inputs)
	if (locale === "it") return it_components_stats_offersyear1(inputs)
	if (locale === "hu") return hu_components_stats_offersyear1(inputs)
	if (locale === "nl") return nl_components_stats_offersyear1(inputs)
	if (locale === "no") return no_components_stats_offersyear1(inputs)
	if (locale === "pl") return pl_components_stats_offersyear1(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_offersyear1(inputs)
	if (locale === "pt") return pt_components_stats_offersyear1(inputs)
	if (locale === "ro") return ro_components_stats_offersyear1(inputs)
	if (locale === "fi") return fi_components_stats_offersyear1(inputs)
	if (locale === "sv") return sv_components_stats_offersyear1(inputs)
	if (locale === "vi") return vi_components_stats_offersyear1(inputs)
	if (locale === "tr") return tr_components_stats_offersyear1(inputs)
	if (locale === "cs") return cs_components_stats_offersyear1(inputs)
	if (locale === "bg") return bg_components_stats_offersyear1(inputs)
	if (locale === "ru") return ru_components_stats_offersyear1(inputs)
	if (locale === "uk") return uk_components_stats_offersyear1(inputs)
	if (locale === "ar") return ar_components_stats_offersyear1(inputs)
	if (locale === "hi") return hi_components_stats_offersyear1(inputs)
	if (locale === "th") return th_components_stats_offersyear1(inputs)
	if (locale === "ja") return ja_components_stats_offersyear1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_offersyear1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_offersyear1(inputs)
	return ko_components_stats_offersyear1(inputs)
});
export { components_stats_offersyear1 as "components.stats.offersYear" }